import { render, staticRenderFns } from "./LeadPartnerCodes.vue?vue&type=template&id=3c7676a4&scoped=true&"
import script from "./LeadPartnerCodes.vue?vue&type=script&lang=js&"
export * from "./LeadPartnerCodes.vue?vue&type=script&lang=js&"
import style0 from "./LeadPartnerCodes.vue?vue&type=style&index=0&id=3c7676a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7676a4",
  null
  
)

export default component.exports